import { useCallback, useState } from 'react';

export default () => {
  const [isVisible, setIsVisible] = useState(false);
  const [formType, setFormType] = useState('');

  const handleClose = useCallback(() => {
    setFormType('');
    setIsVisible(false);
  }, []);

  const handleOpen = useCallback(
    (type) => () => {
      setFormType(type);
      setIsVisible(true);
    },
    [],
  );

  return {
    isVisible,
    handleOpen,
    handleClose,
    formType,
  };
};
